import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=7ed2a7aa"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports